// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-archive[data-v-56ff38ed] {\n  padding: 16px;\n}\n.page-archive[data-v-56ff38ed]:before {\n  content: '';\n  position: absolute;\n  left: 72px;\n  top: 0;\n  bottom: 0;\n  height: 100%;\n  width: 1px;\n  background-color: #fbeee2;\n}\n.page-archive .archive-form-row[data-v-56ff38ed] {\n  margin: 0 0 16px 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
